"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = zeros;
function zeros(size) {
  return new Float32Array(size);
}
//# sourceMappingURL=zeros.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/brain.js/dist/utilities/zeros.js
// module id = 3/vl
// module chunks = 0